module.exports = __webpack_public_path__ + "static/img/zl_btn2.3770870.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/zl_btn2.png
// module id = Ak1C
// module chunks = 7